import {createExtendedHistory} from '@macmillanplatform/ui-core/utils';

const browserHistory = createExtendedHistory();

export default browserHistory;
